module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core\" style=\"height:100%\">\r\n        <div name=\"gridData\" class=\"pf-selectable\" size=\"3\" style=\"width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n                background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\r\n                overflow: hidden;\r\n                padding: 2px 5px 2px 5px;\">\r\n                ")
    ;  for (var i = 0; i < gridData.length; i++) { 
    ; __append("\r\n                <div style=\"padding-bottom:3px; font-weight:")
    ; __append(escapeFn(textWeight))
    ; __append("; white-space: nowrap;\" value=\"")
    ; __append(escapeFn(gridData[i].value))
    ; __append("\">")
    ; __append(escapeFn(gridData[i].caption))
    ; __append("</div>\r\n                ")
    ;  }; 
    ; __append("\r\n                </div>\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n\r\n</div>")
  }
  return __output;

}